import { render, staticRenderFns } from "./CompanyCompany.vue?vue&type=template&id=faa17e70&scoped=true"
import script from "./CompanyCompany.vue?vue&type=script&lang=js"
export * from "./CompanyCompany.vue?vue&type=script&lang=js"
import style0 from "./CompanyCompany.vue?vue&type=style&index=0&id=faa17e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa17e70",
  null
  
)

export default component.exports